import React, { useEffect, useRef, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import ImagerApi from "../../api/ImagerApi";
import { EModuleType } from "../../Model/EModuleType";
import { getModule, getModules } from "../../redux/reducers/ModuleReducer";
import { getLocateDropPathsById, getModuleState } from "../../redux/reducers/ModuleStateReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import LightPathUtil from "../../Utility/LightPathUtil";
import Breadcrumb from "../Header/Breadcrumb";
import Header from "../Header/Header";
import LayoutContent from "../LayoutContent";
import ImageGallery, { GalleryImgSrc } from "./ImageGallery";
import ImagerNavSubMenu from "./ImagerNavSubMenu";

type DropLocationProps = {
  imagerIdentifier: string;
  lightpath: string;
};

const emptyDropLocation: GalleryImgSrc[] = [];

export default function DropLocationView({ match }: RouteComponentProps<DropLocationProps>) {
  const imagerModules = useTypedSelector((state) => getModules(state, EModuleType.IMAGER));
  const imagerIdentifier = match.params.imagerIdentifier || imagerModules[0].identifier;
  const imagerModule = useTypedSelector((state) => getModule(state, imagerIdentifier));
  const locateDropPaths = useTypedSelector((state) => getLocateDropPathsById(state)[imagerIdentifier]);

  const moduleState = useTypedSelector((state) => getModuleState(state, imagerIdentifier));
  const dropLocationIndex = useTypedSelector(
    (state) =>
      {
        if (state.moduleStateStore.locateDropWellName)
        {
          return state.moduleStateStore.locateDropWellName + "-" + state.moduleStateStore.locateDropDropNumber
        }
        return ""
      }

  );

  const imagerState = moduleState.imager;
  const lightpath = match.params.lightpath ? match.params.lightpath : imagerState ? imagerState.activeLightPath : "-1";

  const [dropImages, setDropImages] = useState(emptyDropLocation);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const dropImageRef = useRef<HTMLImageElement>(null);
  const imageContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ImagerApi.getLocateDropImagePaths(imagerIdentifier).then(async (imagePaths) => {
      let dropImages: GalleryImgSrc[] = [];
      for (const imagePath of imagePaths) {
        dropImages.push({
          name: imagePath,
          imageSrc: await ImagerApi.locateDropImage(imagerIdentifier, imagePath),
        });
      }

      setDropImages(dropImages);
    }).catch((error) => {
      console.log(error.message);
    });
  }, [imagerIdentifier, locateDropPaths]);


  const onClickDrop = (index: number) => {
    setSelectedIndex(index);
  };

  const onImageLoad = () => {
    if (dropImageRef.current != null && imageContainerRef.current != null) {
      const widthRatio =
      dropImageRef.current.naturalWidth / imageContainerRef.current.clientWidth;
      const heightRatio =
      dropImageRef.current.naturalHeight / imageContainerRef.current.clientHeight;
      const ratio = Math.max(widthRatio, heightRatio);
      dropImageRef.current.width = dropImageRef.current.naturalWidth / ratio;
      dropImageRef.current.height = dropImageRef.current.naturalHeight / ratio;
    }
  };


  const selectedDropImage =
    dropImages.length > 1 ? (
      <div>
        <div
        className="dropLocation"
          style={{
            position: "absolute",
            fontSize: "44px",
            fontWeight: 700,
            color: "#A6A6A7",
            marginLeft:'10px',
            marginTop:'10px'
          }}
        >
          {dropLocationIndex}
        </div>
        <img
          onLoad={onImageLoad}
          ref={dropImageRef}
          src={dropImages[selectedIndex].imageSrc}
          alt="Drop Location"
          // style={{
          //   width: "auto",
          //   height: "auto",
          // }}
        />
      </div>
    ) : null;

  return (
    <LayoutContent>
      <LayoutContent.Header>
        <Header>
          <Breadcrumb
            items={[
              {
                title: "Drop Location",
                to: "/imager/efi/" + imagerIdentifier + "/" + lightpath,
                disabled: false,
              },
            ]}
          />
          <Breadcrumb
            items={[
              {
                title: imagerModule.name,
                to: "/imager/efi/" + imagerIdentifier + "/" + lightpath,
                disabled: false,
              },
            ]}
          />
          <Breadcrumb
            items={[
              {
                title: LightPathUtil.toName(lightpath),
                to: "/imager/efi/" + imagerIdentifier + "/" + lightpath,
                disabled: false,
              },
            ]}
          />
        </Header>
      </LayoutContent.Header>
      <LayoutContent.Content>
        <div
          ref={imageContainerRef}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          {selectedDropImage}
        </div>
      </LayoutContent.Content>
      <LayoutContent.SubMenu>
        <ImagerNavSubMenu imagerIdentifier={imagerIdentifier} />
      </LayoutContent.SubMenu>
      <LayoutContent.CommandPanel>
        <ImageGallery
          title={"Drop Location Image"}
          items={dropImages}
          onClickItem={onClickDrop}
          selectedIndex={selectedIndex}
        />
      </LayoutContent.CommandPanel>
    </LayoutContent>
  );
}
